import { c as _c } from "react/compiler-runtime";
import EditAvatarMenu from '@/app/[locale]/(worlds)/profile/components/EditAvatarMenu';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { Skeleton } from '@/components/ui/skeleton';
import { useConfigsContext } from '@/context/ConfigsContext';
import defaultHeadIcon from '@/public/images/creator-intro/avatar-2.png';
type ProfileAvatarProps = {
  variant: 'public' | 'private';
  avatarUrl?: string;
};
function ProfileAvatar(t0) {
  const $ = _c(11);
  const {
    variant,
    avatarUrl
  } = t0;
  const {
    store
  } = useConfigsContext();
  const profile = store?.profile;
  const headIconUrl = (variant === "public" ? avatarUrl : profile?.image || profile?.avatarSnapshot) || defaultHeadIcon.src;
  let t1;
  if ($[0] !== headIconUrl) {
    t1 = <AvatarImage key={headIconUrl} src={headIconUrl} alt="profile avatar" className="object-cover" />;
    $[0] = headIconUrl;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <AvatarFallback><Skeleton className="bg-vive-brand-60 size-full" /></AvatarFallback>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1) {
    t3 = <Avatar className="bg-vive-brand-60 size-25 transition-all">{t1}{t2}</Avatar>;
    $[3] = t1;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== headIconUrl || $[6] !== variant) {
    t4 = variant === "private" && <EditAvatarMenu defaultAvatarUrl={headIconUrl} />;
    $[5] = headIconUrl;
    $[6] = variant;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = <div className="relative w-fit">{t3}{t4}</div>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}
export default ProfileAvatar;